<div class="container">
  <div class="row justify-content-center">
    <div class="col-lg-5">
      <div class="card shadow-light border-0  rounded-5 mt-5">
        <div class="card-header rounded-top-5">
          <h3 class="text-center font-weight-light my-4">{{ 'Reset Password' | t }}</h3></div>
        <div class="card-body">
          <form class="form" [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()">
            <div *ngIf="!tokenIsPresent">
              <p class="text-lead text-center">{{ 'We will send you a reset link if your account exists.' | t }}</p>
              <div class="form-group form-floating mb-3">
                <input type="email" name="username" formControlName="username" class="form-control"
                       id="username"
                       aria-describedby="usernameHelp" placeholder="name@example.com">
                <label for="username">{{ 'Email address' | t }}</label>
                <div *ngIf="submitted && resetPasswordForm.controls.username.errors" class="error">
                  <small class="form-text text-warning"
                         *ngIf="resetPasswordForm.controls.username.errors.required">{{ 'Your username is required!' | t }}
                  </small>
                </div>
              </div>
              <div class="mt-4 mb-0">
                <div class="d-grid">
                  <button type="submit" class="btn btn-primary btn-block">{{ 'Reset Password' | t }}
                  </button>
                </div>
              </div>
            </div>
            <div *ngIf="tokenIsPresent">
              <!-- Display password fields and button for resetting the password -->
              <p class="text-lead text-center">{{ 'Please select your new password' | t }}</p>
              <label>{{ 'New Password:' | t }}</label>
              <input type="password" name="password" formControlName="newPassword" class="form-control"
                     id="newPassword"
                     aria-describedby="usernameHelp" placeholder="Password">
              <label>{{ 'Confirm Password:' | t }}</label>
              <input type="password" name="confirmPassword" formControlName="confirmPassword" class="form-control"
                     id="confirmPassword"
                     aria-describedby="confirmPassword" placeholder="Password">
              <div class="mt-4 mb-0">
                <div class="d-grid">
                  <button type="button" (click)="setPassword()" class="btn btn-primary btn-block">{{ 'Apply' | t }}</button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="card-footer rounded-bottom-5 text-center py-4">
          <div class="small"><a routerLink="/login">{{ 'Go back to login' | t }}</a></div>
        </div>
      </div>
    </div>
  </div>
</div>
